import React from 'react'
import { StyledBox, StyledHr } from './ContactOverview';
import StyledText from '../../../components/StyledComponents/StyledText';
import { useTheme } from '../../../middleware/ThemeContext';
import { formatDateDefault, formatTimezone } from '../../../utils/helper';
import { font } from '../../../utils/themes';

interface LoginActivityProps {
    data: any;
    //   refetch?: () => void;
}

const ContactLoginActivity: React.FC<LoginActivityProps> = ({ data }) => {
    const { theme } = useTheme();
    return (
        <div
        >
            <div className="d-flex align-items-center justify-content-between">
                {/* <StyledText
            fontSize="16px"
            fontWeight={700}
            textColor={theme.CorporateTheme.colors.headerColor}
            className="mb-0 py-3"
        >
            Last Login Activity
        </StyledText> */}
                {/* {editMode ? (
            <div className="d-flex align-items-center gap-2 ">
            {isLoading ? (
                <LoadingCircleIcon className="text-black" />
            ) : (
                <TickIcon
                className="cursor-pointer"
                onClick={updateContactEmail}
                />
            )}
            <CrossIcon
                className={`${isLoading && 'class-disable'} cursor-pointer`}
                onClick={() => setEditMode(false)}
                color={theme.CorporateTheme.colors.textSecondary}
            />
            </div>
        ) : (
            <EditIcon
            className="cursor-pointer"
            onClick={() => setEditMode(true)}
            color={theme.CorporateTheme.colors.textSecondary}
            />
        )} */}
            </div>
            <div className="d-flex flex-column gap-3">
                <div className="d-flex gap-1"><StyledText
                    fontSize="14px"
                    fontWeight={600}
                    textColor={theme.CorporateTheme.colors.lightSecondary}
                >
                    Login Email:
                </StyledText>

                    <StyledText
                        fontSize="14px"
                        fontWeight={400}
                        textColor={theme.CorporateTheme.colors.textSecondary}
                    >
                        {data?.email}
                    </StyledText></div>
                <div className="d-flex gap-1">

                    <StyledText
                        fontSize="14px"
                        fontWeight={600}
                        textColor={theme.CorporateTheme.colors.lightSecondary}
                    >
                        Login Date:
                    </StyledText>

                    <StyledText
                        fontSize="14px"
                        fontWeight={400}
                        textColor={theme.CorporateTheme.colors.textSecondary}
                        fontFamily={font.lato}
                    >
                        {   data?.lastLoginAt === null ? "-" :
                            // new Date(data?.lastLoginAt ?? "").toLocaleDateString(
                            //     "en-US",
                            //     {
                            //         year: "numeric",
                            //         month: "long",
                            //         day: "numeric",
                            //     }
                            // )
                            formatDateDefault(data?.lastLoginAt)
                        }
                    </StyledText>
                </div>

                <div className="d-flex gap-1">
                    <StyledText
                        fontSize="14px"
                        fontWeight={600}
                        textColor={theme.CorporateTheme.colors.lightSecondary}
                    >
                        Login Time:
                    </StyledText>
                    <StyledText
                        fontSize="14px"
                        fontWeight={400}
                        textColor={theme.CorporateTheme.colors.textSecondary}
                        fontFamily={font.lato}
                    >
                        { data?.lastLoginAt === null ? "-" :
                        new Date(data?.lastLoginAt ?? "").toLocaleString(
                            "en-US",
                            {
                                hour: "numeric",
                                minute: "numeric",
                                hour12: true,
                            }
                        )}
                    </StyledText>
                </div>

                <div className="d-flex gap-1">
                    <StyledText
                        fontSize="14px"
                        fontWeight={600}
                        textColor={theme.CorporateTheme.colors.lightSecondary}
                    >
                        Time Zone:
                    </StyledText>
                    <StyledText
                        fontSize="14px"
                        fontWeight={400}
                        textColor={theme.CorporateTheme.colors.textSecondary}
                        fontFamily={font.lato}
                    >
                        {data?.lastLoginAt ? (
                            formatTimezone(data.lastLoginAt)
                        ) : "-"}
                    </StyledText>
                </div>

            </div>
        </div>
    )
}

export default ContactLoginActivity